// extracted by mini-css-extract-plugin
export var container = "WidgetFormQuote-module--container--W6sbp";
export var textContainer = "WidgetFormQuote-module--textContainer--22TOt";
export var quote = "WidgetFormQuote-module--quote--15QXI";